import React from 'react'
import { Link } from 'react-router-dom'
import featureImg1 from '../../assets/img/blog/feature1.jpeg'
import featureImg2 from '../../assets/img/blog/feature2.jpeg'
import featureImg3 from '../../assets/img/blog/feature3.jpeg'
import featureImg4 from '../../assets/img/blog/feature4.jpeg'
import featureImg5 from '../../assets/img/blog/feature5.jpeg'
import blog1 from '../../assets/img/blog/blog1.jpeg'
import { SearchNormal1,ArrowLeft,ArrowRight } from 'iconsax-react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import CTAButton from '../../components/CTA/CTAButton'
import { Helmet } from "react-helmet-async";
function Blog() {

    const stories = [
        {
            id: 1,
            title: "NEWS ITEM TITLE #1",
            subtext: "Subtext that tells more about the publication yada yada yada",
            image: featureImg1,
            large: true
        },
        {
            id: 2,
            title: "NEWS ITEM TITLE #1",
            subtext: "Subtext that tells more about the publication yada yada yada",
            image: featureImg2,
        },
        {
            id: 3,
            title: "NEWS ITEM TITLE #1",
            subtext: "Subtext that tells more about the publication yada yada yada",
            image: featureImg3,
        },
        {
            id: 4,
            title: "NEWS ITEM TITLE #1",
            subtext: "Subtext that tells more about the publication yada yada yada",
            image: featureImg4,
        },
        {
            id: 5,
            title: "NEWS ITEM TITLE #1",
            subtext: "Subtext that tells more about the publication yada yada yada",
            image: featureImg5,
        }
    ];

    const RecentStories =  [
        {
            id: 1,
            title: "Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret",
            image: blog1
        },
        {
            id: 2,
            title: "Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret",
            image: blog1
        },
        {
            id: 3,
            title: "Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret",
            image: blog1
        },
        {
            id: 4,
            title: "Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret",
            image: blog1
        }
    ];

    const posts = [ 
        {
            id: 1,
            title: "Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret",
            subtext: "Lorem Ipsum Dolor Amet Si Yada Yada Yada Expecto Patronum Lorem Ipsum Dolor Amet Si Yada Yada Yada Expecto Patronum",
            image: blog1,
            date: "Dec 27th, 2024",
            readTime: "5-Minute Read",
            categories: ["Category #1", "Category #2"]
        },
        {
            id: 2,
            title: "Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret",
            subtext: "Lorem Ipsum Dolor Amet Si Yada Yada Yada Expecto Patronum Lorem Ipsum Dolor Amet Si Yada Yada Yada Expecto Patronum",
            image: blog1,
            date: "Dec 27th, 2024",
            readTime: "5-Minute Read",
            categories: ["Category #1", "Category #2"]
        },
        {
            id: 3,
            title: "Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret",
            subtext: "Lorem Ipsum Dolor Amet Si Yada Yada Yada Expecto Patronum Lorem Ipsum Dolor Amet Si Yada Yada Yada Expecto Patronum",
            image: blog1,
            date: "Dec 27th, 2024",
            readTime: "5-Minute Read",
            categories: ["Category #1", "Category #2"]
        },
        {
            id: 4,
            title: "Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret",
            subtext: "Lorem Ipsum Dolor Amet Si Yada Yada Yada Expecto Patronum Lorem Ipsum Dolor Amet Si Yada Yada Yada Expecto Patronum",
            image: blog1,
            date: "Dec 27th, 2024",
            readTime: "5-Minute Read",
            categories: ["Category #1", "Category #2"]
        },
        {
            id: 5,
            title: "Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret",
            subtext: "Lorem Ipsum Dolor Amet Si Yada Yada Yada Expecto Patronum Lorem Ipsum Dolor Amet Si Yada Yada Yada Expecto Patronum",
            image: blog1,
            date: "Dec 27th, 2024",
            readTime: "5-Minute Read",
            categories: ["Category #1", "Category #2"]
        },
        {
            id: 6,
            title: "Lorem Ipsum Title -Dolor Amet Expecto Patronum Bene Gessaret",
            subtext: "Lorem Ipsum Dolor Amet Si Yada Yada Yada Expecto Patronum Lorem Ipsum Dolor Amet Si Yada Yada Yada Expecto Patronum",
            image: blog1,
            date: "Dec 27th, 2024",
            readTime: "5-Minute Read",
            categories: ["Category #1", "Category #2"]
        },
    ];
    return (
        <>
           <Helmet>
               <title>Blog | Cardplot</title>
           </Helmet>
            <section className='breadcrumb__section bg-overlay '>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb__text">
                                <h3 className='breadcrumb__text__head'> Cardplot News </h3>
                                <p className='breadcrumb__text__content color__blue size_pricing'>
                                    Latest Stories on Cardplot
                                </p>
                            </div>
                            <div className="position-relative my-3">
                                <form className="d-flex align-items-center rounded-pill border px-3 py-1 bg-white mx-auto" style={{ maxWidth: "500px" }}>
                                    <SearchNormal1 className="me-2" color="#6c757d" />
                                    <input type="search" name="search" placeholder="Search for articles" className="form-control border-0 shadow-none" style={{ flex: 1 }} />
                                    <button type="submit" className="btn btn-dark btn-sm rounded-pill px-3" style={{ backgroundColor: "#2A0A7D"}}> Search </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='blog__category__container pt-5 pb-5'>
                <div className='container'>
                    <div className='row justify-content-center align-items-center '>
                        <div className='col-6 col-lg-2 col-md-12 col-sm-6 mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    Virtual Accounts
                                </Link>
                            </div>
                        </div>
                        <div className='col-6 col-lg-2 col-md-12 col-sm-6 mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    Virtual Cards
                                </Link>
                            </div>
                        </div>
                        <div className='col-6 col-lg-2 col-md-12 col-sm-6 mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    New Ghanian Tax Policy
                                </Link>
                            </div>
                        </div>
                        <div className='col-6 col-lg-2 col-md-12 col-sm-6 mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    Malawian currency surge
                                </Link>
                            </div>
                        </div>
                        <div className='col-6 col-lg-2 col-md-12 col-sm-6 mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    Business Accounts
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='blog__featured__section'>
                <div className="container py-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2 className="h3 mb-0">Featured Stories</h2>
                        <Link className="text-decoration-none btn__featured__view" to="/blog/popular-stories">View All</Link>
                    </div>

                    <div className="row g-4">
                        {stories.map((story, index) => (
                            <div
                                key={story.id}
                                className={`${index === 0 ? 'col-12 col-md-8' : 'col-12 col-md-4'}`}
                            >
                                <div className="card h-100 border-0">
                                    <div className="position-relative">
                                        <img
                                            src={story.image}
                                            className="card-img h-100 object-fit-cover"
                                            alt={story.title}
                                            style={{ minHeight: '240px' }}
                                        />
                                        <div className="blog__featured__overlay">
                                            <div className="blog__featured__overlay__content  p-4 ">
                                                <h3 className="h4 mb-2">{story.title}</h3>
                                                <p className="mb-0 small opacity-75">{story.subtext}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className='blog__recent__section padding__tb'>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <h2 className="h3 mb-0">Most Recent Stories</h2>
                            {/* Custom navigation buttons */}
                            <div className='custom__navigation__buttons pt-4 ps-0 pe-0'>
                                <button className="btn btn-link text-primary me-2 ">
                                    <ArrowLeft size="32" className="swiper-button-prev-custom"/>
                                </button>
                                <button className="btn btn-link text-primary ">
                                    <ArrowRight size="32" className="swiper-button-next-custom"/>
                                </button>
                            </div>
                        </div>
                        <div className='col-12 col-md-8'>
                            <Swiper
                                modules={[Navigation, Pagination]}
                                spaceBetween={30}
                                slidesPerView={3}
                                navigation={{
                                    prevEl: '.swiper-button-prev-custom',
                                    nextEl: '.swiper-button-next-custom',
                                }}
                                pagination={{
                                    clickable: true,
                                    el: '.swiper-custom-pagination',
                                    bulletClass: 'btn btn-link p-1',
                                    bulletActiveClass: 'text-primary',
                                }}
                                breakpoints={{
                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 20
                                    },
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 30
                                    },
                                    1024: {
                                        slidesPerView: 3,
                                        spaceBetween: 30
                                    }
                                }}
                            >
                                {RecentStories.map((story) => (
                                    <SwiperSlide key={story.id}>
                                        <div className="blog__recent__card">
                                            <img
                                                src={story.image}
                                                className="blog__recent__card__img img-fluid"
                                                alt={story.title}
                                               
                                            />
                                            <div className="blog__recent__body px-0">
                                                <h5 className="blog__recent__title">{story.title}</h5>
                                            </div>
                                        </div>
                                        {/* Custom pagination */}
                                        <div className="swiper-custom-pagination"></div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </section>

            <section className='blog__section padding__tb'>
                <div className='container'>
                    <div className='row' style={{paddingBottom: '2rem'}}>
                        <div className='col-12'>
                            <h2 className='blog__section__title'>All Stories</h2>
                        </div>
                    </div>
                    <div className='row'>
                        {posts.map((post) => (
                            <div key={post.id} className='col-12 col-md-6 col-lg-4 mb-5'>
                                <div className='blog__card'>
                                    <Link to='/blog/details'>
                                      <img src={post.image} className='blog__card__img img-fluid' alt={post.title} />
                                    </Link>
                                    <div className='blog__card__body px-3'>
                                        <div className='blog__card__category'>
                                        {post.categories.map((category, idx) => (
                                        <span key={idx} className=" me-2">
                                            {category}
                                        </span>
                                        ))}
                                        </div>
                                        <Link to='/blog/details' className='text-decoration-none'><h3 className='blog__card__title'>{post.title}</h3></Link>
                                        <Link to='/blog/details' className='text-decoration-none'><p className='blog__card__subtitle'>{post.subtext}</p></Link>
                                    </div>
                                    <div className='blog__card__footer'>
                                        <span>Dec 27th, 2024</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <CTAButton />

        </>
    )
}

export default Blog